import { Component, Input, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';

import { Subject, forkJoin, map, mergeMap } from 'rxjs';
import { ProyectoService } from '../../../services/proyecto.service';
import { IndicadoresService } from '../../../services/indicadores.service';
import { ModalService } from '../../../../../services/modal.service';
import { AlertService } from '../../../../../services/alert.service';
import { validadorFechaIntervalo } from 'src/app/helpers/validator-form';
import { IpPublicService } from 'src/app/services/ip-public.service';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { EquipoGerencialService } from 'src/app/modulos/catalogos-proces/services/equipo.gerencial.service';
import { ParticipanteElementoService } from '../../../services/participante.elemento.service';
import { ComunService } from 'src/app/modulos/catalogos-proces/services/comun.service';
import { ObjetivoService } from '../../../services/objetivo.service';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { CumpleIndicadorService } from 'src/app/modulos/elementos-plan/services/cumple-indicador.service';
import { ConstantsCatalogosIdService } from './../../../../../services/constants-catalogos-id.service';
import { ImpresionService } from '../../../services/impresion.service';
@Component({
  selector: 'app-indicadores-proyectos',
  templateUrl: './indicadores-proyectos.component.html',
  styleUrls: ['./indicadores-proyectos.component.css']
})
export class IndicadoresProyectosComponent {
  public formProyectoIndicadores: UntypedFormGroup;
  public submitted = false;
  public dataProyectoIndicadores: any = [];
  public dataObjetivo: any = [];
  public dataIndicadores: any[] = [];
  public dataProyectos: any[] = [];
  private idDeleteRegister: number = 0;
  private currentUser!: any;
  private ipAddress!: string;
  private buffer!: any;
  public nameModalProyecto: string = 'Proyecto-modalNewEdit'
  public nameAppProyecto = ' INDICADOR-PROYECTO';
  public selectItems: any = [];
  public idSprAmbiente: number = 0;
  private idSprPlanAnio: number = 0;
  public nameModalConfigProyect: string = 'modalConfigProyecto'
  public nameModalCumple: string = 'modalCumpleProyecto'
  public dataResponsableProceso: any = [];
  public dataElementosParticpantes: any = [];
  public dataEquipoGerencial!: any;
  public dataTipoParticpacion: any = [];
  public dataIndicadorSendConfig: any[0] = [0];
  public descripcionIndicador !: any;
  public descripcionConfigIndicador !: any;
  public cumpleIndicadores = [];
  public nombreProyecto = [];
  public desripcionProyecto!: any;
  //tipoParticipante = 293;
  public estadoActivo: number = 1;
  public dataCumpleIndicador: any[] = [];
  idSprTipoParticipante = ConstantsCatalogosIdService.ID_COMUNES_TIPO_PARTICIPANTE;
  public idResponsable = ConstantsCatalogosIdService.ID_COMUNES_RESPONSABLE;
  fechaIniciObjetivo: any;
  fechaFinObjetivo: any;
  public planAnioSeleccionadoRedux: any = null;
  public dataObjetivosPorAnio: any = null;
  public idSprNivel: number = 0;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  isDtInitialized: boolean = false;

  @Input() set init(objetivo: any) {
    this.initApp(objetivo);
  }
  @Input() set idsObjetivos(dataObjetivosPorAnio: any) {
    this.dataObjetivosPorAnio = dataObjetivosPorAnio;
  }

  @Input() set planAnual(planAnioSeleccionadoRedux: any) {
    this.planAnioSeleccionadoRedux = planAnioSeleccionadoRedux;
  }
  readonly constant = ConstantsCatalogosIdService;
  constructor(
    public modal: ModalService,
    private indicadorService: IndicadoresService,
    private ip: IpPublicService,
    private alert: AlertService,
    private fb: FormBuilder,
    private comunService: ComunService,
    private proyectoService: ProyectoService,
    private objetivoService: ObjetivoService,
    public store: Store<AppState>,
    private participanteElementoService: ParticipanteElementoService,
    private equipoGerencialService: EquipoGerencialService,
    private cumpleIndicadorService: CumpleIndicadorService,
    private srvImpresion: ImpresionService,

  ) {
    this.buffer = localStorage.getItem('currentUser');
    this.currentUser = JSON.parse(this.buffer);
    this.selectItems = [
      { value: '', label: 'Selecione..' },
      { value: 1, label: 'Activo' },
      { value: 2, label: 'Inactivo' },
    ];
    //this.idSprAmbiente = this.currentUser.idSprAmbiente;
  }

  initApp(data: string = 'proyecto') {
    this.getIpPublic();
    if (data == 'proyecto') {
      this.store.select('globalApp').subscribe(response => {
        this.planAnioSeleccionadoRedux = response.planAniosSeleccionado;
        this.idSprNivel = response.ambienteSeleccionado.nivel.idSprNivel;
        this.idSprAmbiente = response.ambienteSeleccionado.idSprAmbiente;
        this.idSprPlanAnio = response.planAniosSeleccionado.idSprPlanAnio;
        this.initProyectoIndicadores();
      })
    }
  }
  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  setDataTable() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      destroy: true,
      language: {
        //url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
      },
    };
  }

  initProyectoIndicadores() {
    forkJoin([
      this.objetivoService.list(`?idSprAmbiente=${this.idSprAmbiente}&idSprPlanAnio=${this.idSprPlanAnio}&estado=${this.estadoActivo}`),
      this.proyectoService.list(`?idSprAmbiente=${this.idSprAmbiente}&estado=${this.estadoActivo}`),
      this.indicadorService.list(),
      this.participanteElementoService.list('?estado=1'),
      this.equipoGerencialService.list('?idSprAmbiente=' + this.idSprAmbiente + '&estado=1&idSprTipoParticipante=' + this.idResponsable),
      this.comunService.list('?spr_idSprComun=' + this.idSprTipoParticipante),
      this.cumpleIndicadorService.list()
    ]).pipe(map(
      ([objetivos, proyectos, indicadores, participantes, equipoGerencial, tipoParticipante, cumpleIndicador]) => {
        this.dataObjetivo = objetivos;
        this.dataProyectos = proyectos;
        this.dataIndicadores = indicadores;
        this.dataElementosParticpantes = participantes;
        this.dataEquipoGerencial = equipoGerencial;
        this.dataTipoParticpacion = tipoParticipante;
        this.dataCumpleIndicador = cumpleIndicador;


        this.mapingDataProyectoIndicadores();
        this.mapeoEquipoGerencialTipoParticipa();
        this.mapeoProcesosParticipante();
        //this.listElementosComun();
      })).subscribe();
  }

  mapeoProcesosParticipante() {
    let dataProcess = [];
    for (let i = 0; i < this.dataProyectoIndicadores.length; i++) {
      for (let j = 0; j < this.dataElementosParticpantes.length; j++) {
        if (this.dataProyectoIndicadores[i].idSprIndicador === this.dataElementosParticpantes[j].idSprIndicador) {
          for (let k = 0; k < this.dataEquipoGerencial.length; k++) {
            if (this.dataElementosParticpantes[j].idSprEquipoGerencial === this.dataEquipoGerencial[k].idSprEquipoGerencial) {

              this.dataProyectoIndicadores[i].gradoNombres = this.dataEquipoGerencial[k].gradoNombres;
              this.dataProyectoIndicadores[i].idSprEquipoGerencial = this.dataElementosParticpantes[j].idSprEquipoGerencial;
              this.dataProyectoIndicadores[i].idSprParticipanteElemento = this.dataElementosParticpantes[j].idSprParticipanteElemento;

            }
          }
        }
      }
    }
  }

  mapeoEquipoGerencialTipoParticipa() {
    let dataProcess = [];

    for (let j = 0; j < this.dataTipoParticpacion.length; j++) {
      for (let i = 0; i < this.dataEquipoGerencial.length; i++) {
        if ((this.dataTipoParticpacion[j].idSprComun === this.dataEquipoGerencial[i].idSprTipoParticipante) && this.dataEquipoGerencial[i].estado === this.estadoActivo) {
          dataProcess.push({
            idSprEquipoGerencial: this.dataEquipoGerencial[i].idSprEquipoGerencial,
            nombres: this.dataEquipoGerencial[i].gradoNombres,
            cedula: this.dataEquipoGerencial[i].cedula,
            participacion: this.dataTipoParticpacion[j].nombre
          })
        }
      }
    }
    this.dataResponsableProceso = dataProcess;
  }

  mapingDataProyectoIndicadores() {
    let nombreProyecto;
    let idSprProyecto;
    this.dataProyectoIndicadores = []
    let indiceUno = 0; let dataProcess: any = [];
    for (let i = 0; i < this.dataObjetivo.length; i++) {
      for (let j = 0; j < this.dataProyectos.length; j++) {
        if (this.dataObjetivo[i].idSprObjetivo == this.dataProyectos[j].idSprObjetivo) {
          for (let k = 0; k < this.dataIndicadores.length; k++) {
            if (this.dataIndicadores[k].idSprProyecto == this.dataProyectos[j].idSprProyecto) {
              dataProcess.push({
                idSprIndicador: this.dataIndicadores[k].idSprIndicador,
                nombre: this.dataIndicadores[k].nombre,
                descripcion: this.dataIndicadores[k].descripcion,
                fechaInicio: this.dataIndicadores[k].fechaInicio,
                unidadInformacion: this.dataIndicadores[k].unidadInformacion,
                estado: this.dataIndicadores[k].estado,
                idSprProyecto: this.dataIndicadores[k].idSprProyecto,
                idSprResponsable: this.dataIndicadores[k].idSprResponsable
              }); indiceUno++;
            }
          }
          this.dataProyectoIndicadores.push({
            nombreProyecto: this.dataProyectos[j].nombreProyecto,
            idSprProyecto: this.dataProyectos[j].idSprProyecto,
            indicadores: dataProcess
          }); dataProcess = [];
        }
      }
    }
  }

  get appForm() {
    return this.formProyectoIndicadores.controls;
  }

  ngOnInit(): void {
    this.store.select('globalApp').subscribe(response => {
      this.planAnioSeleccionadoRedux = response.planAniosSeleccionado
      this.fechaIniciObjetivo = response.planAniosSeleccionado.fechaInicio
      this.fechaFinObjetivo = response.planAniosSeleccionado.fechaFin
      this.getIpPublic();
      this.setFormProyecto();
    })
  }

  getIpPublic() {
    this.ip.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  setFormProyecto(idSprProyecto: string = " ") {
    this.formProyectoIndicadores = this.fb.group({
      idSprProyecto: [idSprProyecto],
      idSprIndicador: [],
      idSprEquipoGerencialAnterior: ['', []],
      idSprParticipanteElemento: ['', []],
      idSprEquipoGerencial: ['', [Validators.required]],
      nombre: ['', [Validators.required]],
      descripcion: [],
      unidadInformacion: [],
      fechaInicio: ['', [Validators.required, validadorFechaIntervalo(this.fechaIniciObjetivo, this.fechaFinObjetivo)]],
      estado: ['', [Validators.required]],
    });
  }

  delete(row: any) {
    this.idDeleteRegister = row.idSprIndicador;
    this.modal.open('delete-proyecto');
  }

  confirmDelete() {
    if (this.idDeleteRegister > 0) {
      this.indicadorService.update({
        "idSprIndicador": this.idDeleteRegister,
        "usuario": this.currentUser.idSprUsuario,
        "delLog": "S",
        "ip": this.ipAddress
      }).subscribe(resp => {
        this.initApp();
        this.alert.deleteOk();
        this.modal.close();
      }, (err) => {
        this.alert.deleteError();
        this.modal.close();
      });
    }
  }

  configuracionIndicador(obj: any) {
    this.setFormProyecto()
    this.descripcionIndicador = obj.nombre;
    this.dataIndicadorSendConfig = obj;
    this.openModalConfigIndicador();

  }

  cumpleInit(obj: any) {
    this.descripcionConfigIndicador = obj.nombre;
    this.dataIndicadorSendConfig = obj;
    this.openModalCumpleIndicador();
  }

  onImprimir(dataRow: any) {
    const imagenPath = 'assets/images/escudo.jpg';
    const encabezado = ["N°", "Nombre", "Descripcion", "Unidad Informacion", "Fecha Inicio"];
    //const cuerpo = ["1111", "JUAN","PRUEBA", "PRUEBA"];
    let cuerpo
    //for(let i = 0; i < dataRow.length; i++) {

    cuerpo = [dataRow.idSprIndicador, dataRow.nombre, dataRow.descripcion, dataRow.unidadInformacion, dataRow.fechaInicio];
    //}
    this.srvImpresion.imprimir(imagenPath, encabezado, cuerpo, "POLICÍA NACIONAL DEL ECUADOR \n COMANDO GENERAL-DEPARTAMENTO DE CONTROL \n DIRECCIÓN NACIONAL DE PLANIFICACIÓN Y GESTIÓN ESTRATÉGICA", true)
  }

  editConfigIndicador(obj: any, row: any) {
    this.onResetForm();
    this.nombreProyecto = row.nombreProyecto;
    this.setFormProyecto(obj.idSprProyecto)
    this.formProyectoIndicadores.patchValue({
      idSprIndicador: obj.idSprIndicador,
      idSprProyecto: obj.idSprProyecto,
      idSprEquipoGerencial: obj.idSprResponsable,
      idSprEquipoGerencialAnterior: obj.idSprEquipoGerencial,
      idSprParticipanteElemento: obj.idSprParticipanteElemento,
      nombre: obj.nombre,
      descripcion: obj.descripcion,
      unidadInformacion: obj.unidadInformacion,
      fechaInicio: obj.fechaInicio,
      estado: obj.estado,
    });
    this.modal.open(this.nameModalProyecto);
  }

  onSubmit() {
    this.submitted = true;
    this.formProyectoIndicadores.value.usuario = this.currentUser.idSprUsuario;
    this.formProyectoIndicadores.value.ip = this.ipAddress;
    this.formProyectoIndicadores.value.idSprResponsable = this.formProyectoIndicadores.value.idSprEquipoGerencial;

    if (!this.formProyectoIndicadores.invalid) {
      if (this.formProyectoIndicadores.value.idSprIndicador == null) {
        this.indicadorService.create(this.formProyectoIndicadores.value).subscribe(
          (resp) => {
            ///this.initApp();
            this.initProyectoIndicadores();
            this.closeModalConfiguracion();
            this.alert.createOk();
            this.initApp();
          },
          (err) => {
            this.alert.createError();
          }
        );
      } else {
        this.indicadorService.update(this.formProyectoIndicadores.value).subscribe(
          (resp) => {
            this.initProyectoIndicadores();
            this.closeModalConfiguracion();
            this.alert.updateOk();
            this.initApp();
          },
          (err) => {
            this.alert.updateError();
          }
        );
      }
    } else {
      return;
    }
  }

  ConfguracionProyectoInit(obj: any) {
    this.desripcionProyecto = obj.nombreProyecto;

  }


  reDrawDataTable() {
    // Redibujar la tabla al actualizar datos
    if (this.isDtInitialized) {
      this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next(null);
      });
    } else {
      this.isDtInitialized = true;
      this.dtTrigger.next(null);
    }
  }

  onResetForm() {
    this.submitted = false;
    this.formProyectoIndicadores.reset();
  }

  openModalProyectos(row: any) {
    this.onResetForm();
    this.setFormProyecto(row.idSprProyecto);
    this.nombreProyecto = row.nombreProyecto;
    this.modal.open(this.nameModalProyecto);
  }

  openModalConfigIndicador() {
    this.onResetForm();
    this.modal.open(this.nameModalConfigProyect);
  }
  openModalCumpleIndicador() {
    this.onResetForm();
    this.modal.open(this.nameModalCumple);
  }

  closeModalConfiguracion() {
    this.modal.closeId('Proyecto-modalNewEdit');
    this.reDrawDataTable()
  }
}
